import RestCrudThunks from './restCrudThunksGenerator';
import { ROLE_TYPES } from '../utils/DataConstants';
import { CONTRACTORS_CRUD_ACTION_CREATORS } from '../actions/contractors_private_network_actions';

// private_network/supplier_supplier_relationships
export const ContractorPrivateNetworksRestCrudThunksForBuyer = new RestCrudThunks(
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	CONTRACTORS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.BUYER,
	false,
	'private_network/'
);
export const ContractorPrivateNetworksRestCrudThunksForSupplier = new RestCrudThunks(
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	'supplier_supplier_relationships',
	CONTRACTORS_CRUD_ACTION_CREATORS,
	null,
	ROLE_TYPES.SUPPLIER,
	false,
	'private_network/'
);
